/**
 * @description Wrapper para integrar o PetFormModal no fluxo de agendamento
 * @module VetPetFormWrapper
 */

import { useState } from "react";
import { Stack, Typography } from "@mui/material";
import PetFormModal, { IPetFormData } from "@/fluxvet/components/PetFormModal";
import dayjs from "dayjs";

interface IProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (petData: IPetFormData) => void | Promise<void>;
  loading?: boolean;
}

/**
 * Wrapper para o PetFormModal
 * Gerencia o estado do formulário e integra com o fluxo de agendamento
 */
export function VetPetFormWrapper({
  open,
  onClose,
  onSubmit,
  loading = false,
}: IProps) {
  // Estado inicial do formulário de pet
  const [formData, setFormData] = useState<IPetFormData>({
    name: "",
    birthDate: null,
    color: null,
    state: null,
    city: "",
    species: null,
    breed: null,
    sex: "",
    genderStatus: null,
  });

  // Handler para mudanças no formulário
  const handleFormChange = (field: keyof IPetFormData, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Validação do formulário
  const isValid =
    formData.name.trim() !== "" &&
    formData.species !== null &&
    formData.sex !== "" &&
    formData.genderStatus !== null &&
    formData.state !== null;

  // Handler para submit
  const handleSubmit = async () => {
    if (isValid) {
      await onSubmit(formData);
      // Limpa o formulário após submit bem-sucedido
      setFormData({
        name: "",
        birthDate: null,
        color: null,
        state: null,
        city: "",
        species: null,
        breed: null,
        sex: "",
        genderStatus: null,
      });
    }
  };

  return (
    <PetFormModal
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      mode="add"
      formData={formData}
      onFormChange={handleFormChange}
      loading={loading}
      isValid={isValid}
      // Não solicita foto durante o cadastro no fluxo de agendamento
      photoPreviewUrl={null}
      onPhotoChange={undefined}
      onPhotoRemove={undefined}
    />
  );
}
